<template lang="pug">
  .component-client-logs
    .action-bar
      h2 Logs
    .tabs-inner-content
      accordion
        accordion-item(v-for="l in items", :title="$dateFormat(l.date.date,\"DD-MM-YYYY HH:mm:ss\") +' | '+l.action")
          log(:item="l")

</template>
<script type="text/babel">
  import KeplerBackofficeSdk from "src/lib/kepler/backoffice";
  import Accordion from "../../structure/foundation/Accordion/Accordion";
  import AccordionItem from "../../structure/foundation/Accordion/AccordionItem";
  import Log from "components/backoffice/Log";

  export default {
    name: "DriverLogs",
    components: {
      Log,
      Accordion,
      AccordionItem
    },
    data() {
      return {
        items: [],
      }
    },
    created() {
      KeplerBackofficeSdk.clients.list(1, 1000).logs(this.$route.params.id, (data) => {
        this.items = data.items
      })
    }
  }
</script>
<style lang="sass" rel="stylesheet/sass">
</style>



// WEBPACK FOOTER //
// ClientLogs.vue?00baa044